import React from 'react';
import { EmojiDiv, IconDiv, SVGIconDiv, Text } from './style';
import { PROJECT_ICON_TYPE } from '../../global/constants';

import IconSvg from '../../assets/images/svg/iconSvg';

interface IconDivProps {
  backgroundColor?: string;
  size?: number;
  type?: number;
  reference: string;
  projectName: string;
  borderRadius?: string;
  iconSize?: number;
  isClickable?: boolean;
}

const ProjectIconAvatar: React.FC<IconDivProps> = ({
  backgroundColor,
  size = 26,
  type = 1, // Default type
  reference = '',
  projectName,
  borderRadius = '6px',
  iconSize = 16, // Default icon size.
  isClickable = false //Default hover state will not be there.
}) => {
  const renderContent = () => {
    switch (type) {
      case PROJECT_ICON_TYPE.DEFAULT:
        return <Text>{projectName?.[0]?.toUpperCase()}</Text>;
      case PROJECT_ICON_TYPE.ICON: // ICON
        return (
          <SVGIconDiv iconSize={iconSize}>
            <IconSvg name={reference} width={`${iconSize}px`} height={`${iconSize}px`} viewBox='0 0 20 20' />
          </SVGIconDiv>
        );
      case PROJECT_ICON_TYPE.EMOJI: // EMOJI
        return <EmojiDiv iconSize={iconSize}>{reference || '😊'}</EmojiDiv>;
      case PROJECT_ICON_TYPE.IMAGE: // IMAGE
        return <img src={reference} alt='' />;
      default:
        return <p>A</p>;
    }
  };
  return (
    <IconDiv
      size={size}
      backgroundColor={backgroundColor}
      type={type}
      borderRadius={borderRadius.toString()}
      isClickable={isClickable}>
      {renderContent()}
    </IconDiv>
  );
};

export default ProjectIconAvatar;
